/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.userkey" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.transId" placeholder="输入交易单号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.payStatus" placeholder="请选择支付状态">
          <el-option v-for="type in payStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.item_no" placeholder="请选择项目类型">
         <el-option value=""  key="请选择项目"></el-option>

          <el-option v-for="type in item" :label="type.item_name" :value="type.item_no" :key="type.item_no"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
          <el-date-picker
          size="small"
            v-model="formInline.date"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>


        <el-button v-if="isdaochu == 1" size="small" type="primary" icon="el-icon-refresh-left" @click="dcexcel()">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="identitycard_no" label="身份证号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sex" label="性别" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="age" label="年龄（周岁）" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tel" label="手机号" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="prescription_name" align="center" label="预约项目" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" align="center" label="地址" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="bl_img" align="center" label="病历资料" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt" v-for="il in scope.row.img_list">
              <img :src="il" @click="yulandatu(il)">
            </div>
         </template>
      </el-table-column>
      <el-table-column sortable prop="yysj" align="center" label="预约时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="pay_status"  align="center" label="支付状态" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-show="scope.row.pay_status == 'SUCCESS'"><span style="color: green;">支付成功</span></div>
          <div v-show="scope.row.pay_status == 'SUCCESSBUTHISERROR'"><span style="color: red;">单边账</span></div>
          <div v-show="scope.row.pay_status == 'REFUND'"><span style="color: gray;">已退费</span></div>
          <div v-show="scope.row.pay_status == 'NOTPAY'"><span style="color: red;">未支付</span></div>

         </template>
      </el-table-column>

      <el-table-column sortable prop="pay_amount" align="center" label="支付金额（元）" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="pay_time" align="center" label="支付时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="order_status" align="center" label="订单状态" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-show="scope.row.order_status == '1'  && scope.row.hs_id == 0"><span style="color: red;">已接单</span></div>
            <div v-show="scope.row.order_status == '1' && scope.row.hs_id > 0"><span style="color: red;">已派单</span></div>
            <div v-show="scope.row.order_status == '0' && (scope.row.pay_status == 'SUCCESS' || scope.row.pay_status == 'SUCCESSBUTHISERROR')"><span style="color: green;">待接单</span></div>
            <div v-show="scope.row.order_status == '2'"><span style="color: red;">拒绝接单<Br/>原因:{{scope.row.order_text}}</span></div>
            <div v-show="scope.row.order_status == '3' "><span style="color: green;">订单已完成</span></div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="hushi" align="center" label="分配护士" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
          {{scope.row.hs_name}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="beizhu" label="备注"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="280">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="scope.row.pay_status == 'SUCCESS'  && scope.row.order_status == 0  "
           @click="jiedan(scope.row.id,1,'')">接单
          </el-button>
          <el-button size="mini" type="danger" v-if="scope.row.pay_status == 'SUCCESS'  && scope.row.order_status == 0 "
          @click="bjd(scope.row,2)">拒绝接单</el-button>
          <el-button size="mini" type="success"
          @click="orderdetail(scope.row)">查看详情</el-button>
          <el-dropdown @command="handleCommand"  trigger="hover" v-if="scope.row.order_status == 1 && scope.row.hs_id < 1" >
            <el-button type="primary" size="mini">
              派单
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item v-for="(item,index) in scope.row.hushi"
               :command="beforeHandleCommand(item.hs_id,item.hs_name,scope.row)" :key="index">
               {{item.hs_name}}
               </el-dropdown-item>

              </el-dropdown-menu>
          </el-dropdown>
      </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  <el-dialog :visible.sync="bjdyy" title="不接单的原因"  class="dis" width="40%"
   :close-on-click-modal="false">

      <div class="bnrlb" style="margin-top: 15px;">

          <div class="bnrlb_yy">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入不接单的原因"
              v-model="jd.bujdyy">
            </el-input>
          </div>
      </div>


    <div class="qrbz" @click="qrbc">
          确认保存
    </div>
  </el-dialog>


  <el-dialog :visible.sync="ddxq" title="订单详情"  class="dis" width="60%"
   :close-on-click-modal="false">
   <div class="xqxs_bk">
      <div class="xqxs" >
          <div class="xmmc">
            预约项目 :
          </div>
          <div class="xmnr">
            {{detail.prescription_name}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            项目编号 :
          </div>
          <div class="xmnr">
             {{detail.prescription_nos}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            被服务人:
          </div>
          <div class="xmnr">
            {{detail.patient_realname}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            身份证号
          </div>
          <div class="xmnr">
           {{detail.sfzh}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            联系电话
          </div>
          <div class="xmnr">
           {{detail.tel}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            服务地点
          </div>
          <div class="xmnr">
           {{detail.address}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            预约科室:
          </div>
          <div class="xmnr">
            {{detail.yy_keshi}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            预约护士:
          </div>
          <div class="xmnr">
             {{detail.yy_hushi}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            支付状态:
          </div>
          <div class="xmnr">
            <span v-if="detail.pay_status == 'SUCCESS'">支付成功</span>
            <span v-if="detail.pay_status == 'NOTPAY'">未支付</span>
          </div>
      </div>
        <div class="xqxs" >
                 <div class="xmmc">
              支付金额:
                 </div>
                 <div class="xmnr">
        {{detail.pay_amount}}
                 </div>
             </div>
      <div class="xqxs" >
          <div class="xmmc">
            交易号:
          </div>
          <div class="xmnr">
 {{detail.pay_sn}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            支付时间:
          </div>
          <div class="xmnr">
 {{detail.pay_time}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            订单状态:
          </div>
          <div class="xmnr">
             <span v-if="detail.order_status == 0">待接单</span>
             <span v-if="detail.order_status == 1">已接单</span>
             <span v-if="detail.hs_id > 0 ">已派单</span>
             <span v-if="detail.order_status == 3">订单已完成</span>
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            派单护士:
          </div>
          <div class="xmnr">
             {{detail.hs_name}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            接单时间:
          </div>
          <div class="xmnr">
             {{detail.order_jd_time}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            拒接原因:
          </div>
          <div class="xmnr">
             {{detail.order_text}}
          </div>
      </div>
      <div class="xqxs" >
          <div class="xmmc">
            用户签名:
          </div>
          <div class="xmnr" style="color: black;">
            <img :src="detail.qianming" >
          </div>
      </div>
</div>

  </el-dialog>


    <el-dialog title="预览" :visible.sync="yulan">

      <div style="text-align: center;">
          <img :src="imgUrl" >
      </div>



    </el-dialog>
  </div>
</template>

<script>

import { getZzkdOrder,updateZzkdOrder,getitem ,jiedan,fphs,daochuexcel,is_show_daochu} from '../../api/baseset'

import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false,
      refundVisible: false,
      refund_passwd: '',
      refund_row: [],
      radio: 0,
      payStatus: [
        { key: '请选择', value: 0 },
        { key: '支付成功', value: 'SUCCESS' },
         { key: '未支付', value: 'NOTPAY' },
        { key: '单边账', value: 'SUCCESSBUTHISERROR' },
        { key: '已退费', value: 'REFUND' }
      ],
      payType: [
        { key: '请选择', value: 0 },
        { key: '门诊挂号', value: '门诊挂号' },
        { key: '门诊缴费', value: '门诊缴费' },
        { key: '住院预交金', value: '住院预交金' }
      ],
      itemType:[],
      formInline: {
        page: 1,
        limit: 10
      },
      listData: [], //订单数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      formData:[],
      form: {
        doctorpic: '',
        doctorinfo: ''
      },
      bujdyy:'',
      ddxq:false,
      yulan:false,
      orderqr:[
        {key:'未确认',value:'0'},
        {key:'确认',value:'1'},

      ],
      item:[],
      imgUrl:'',

      isdaochu:0,

      bjdyy:false,
      jd:{
        id:"",
        bujdyy:'',
        status:2
      },
      detail:{}

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getxmitem();
    this.dc();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    dc(){


      is_show_daochu()
       .then(res => {
         console.log(res)
         //this.loading = false
        this.isdaochu = res.data
       })
       .catch(err => {
         //this.loading = false
        // this.$message.error('数据加载失败，请稍后再试！')
       })
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
        getZzkdOrder(parameter)
         .then(res => {
           console.log(res)
           this.loading = false
           if (res.success == false) {
             this.$message({
               type: 'info',
               message: res.msg
             })

           } else {
             this.listData = res.data
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.count
           }
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    },
    getxmitem(){
      getitem()
        .then(res => {
            this.item =res.data
        })
        .catch(err => {

        })

    },
    // 重置搜索
    formReset() {
       this.formInline = {
        page: 1,
        limit: 10
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 10
      console.log(this.formInline)
      this.getdata(this.formInline)
    },
    // 编辑
    edit(row) {
      this.refund_row = row;
      this.refundVisible = true;
      this.form = row
      console.log(row.order_status)
      this.radio = row.order_status+ ""
      //this.radio = '1'
      console.log(this.radio)
    },

    autoOrder(row) {
      this.$confirm('确定要同步订单信息吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.loading = true
        const param = {id:row.id}
        orderToHis(param)
          .then(res => {
            this.loading = false
            this.$message({
              type: 'info',
              message: res.msg
            })
          })
          .catch(err => {
            this.loading = false
            this.$message.error('同步失败，请稍后再试！')
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })
    },
    submitform(){
      var param = this.form;
     param.order_status = this.radio;
     console.log(param);
    // return ;
      updateZzkdOrder(param)
        .then(res => {
          this.loading = false
          this.$message({
            type: 'info',
            message: res.msg
          })
          this.refundVisible = false;
          this.getdata(this.formInline);
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改失败，请稍后再试！')
        })
    },
    yulandatu(url){
      console.log(url)
      this.imgUrl = url;
      this.yulan = true
    },

    dcexcel(){
        let param = this.formInline
        daochuexcel(param)
          .then(res => {
            console.log(res)
            this.loading = false
            this.$message({
              type: 'info',
              message: res.msg
            })
             window.open(res.data);
            //window.location.href=res.data
          //  this.refundVisible = false;
            //this.getdata(this.formInline);
          })
          .catch(err => {
            this.loading = false
            this.$message.error('修改失败，请稍后再试！')
          })
    },
    bjd(row,status){
      this.bjdyy = true
      this.jd.id =row.id;

    },
    beforeHandleCommand(hs_id,hs_name,row){
      return {
       		hs_id:hs_id,
          hs_name:hs_name,
       		row: row
       	}
    },
    handleCommand(row){
      console.log(row)
      return
      let param={id:row.row.id,hs_id:row.hs_id,hs_name:row.hs_name}
      fphs(param).then(res => {
          if(res.code == 0){

             this.getdata(this.formInline)
          }
        //this.$message.success(res.msg);

          return ;
        }
      ).catch(err => {
         this.loading = false
         this.$message.error('数据加载失败，请稍后再试！')
       })
    },
    jiedan(id,status,yuanyin){
      //console.log(row)

      let param={id:id,status:status,yuanyin:yuanyin}

      jiedan(param)
        .then(res => {
          this.loading = false
          this.$message({
            type: 'info',
            message: res.msg
          })
          this.bjdyy = false;
          this.getdata(this.formInline);
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改失败，请稍后再试！')
        })
    },
    qrbc(){
      if(this.jd.bujdyy ==''){
         this.$message.error('请输入不接单的原因！');
         return ;
      }
      this.jiedan(this.jd.id ,this.jd.status,this.jd.bujdyy);

    },
    orderdetail(row){
      console.log(row)
      this.ddxq = true;
      this.detail = row

    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.binajiinput{
  width: 70%;
  float: right;
  margin-right: 10%;
}
.rbj{
  background-color: #666666;
}
.ylt img{
  width: 40px;
  height: 60px;
}
.bnrlb{
    width: 100%;
    height: auo;
    display: flex;
    justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */

  }
  .bnrlb_title{
    margin-right: 20px;
    text-align:right;
    width: 35%;
  }
  .bnrlb_yy{
    width: 65%;
  }
  .bnrlb_yy_qtyy{
    width: 87%;
  }
  .bnrlb_yy_input{
    width:100%;
  }
  .qrbz{
    margin: 0 auto;
    margin-top: 25px;
    width: 70px;
    height: 35px;
    border-radius: 5px 5px 5px 5px;
    background-color: #52BBFF;
    color: white;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
  }
  .xqxs{
    width: 100%;
    height: 45px;
   display: flex;
    line-height: 45px;

    color: #666666;
  }
  .xmmc{
    width: 30%;
    text-align: center;
  }
  .xmnr{
    width: 70%;

  }
  .xqxs_bk{
    width: 92%;
    			height: auto;
    			padding-top: 10px;
    			padding-bottom: 10px;
    			margin: 0 auto;
    			/* border: solid 1px red; */
    			background-color: white;
    			margin-top: 20px;
    			border-radius: 10px 10px 10px 10px;
    			-webkit-box-shadow: #A4DCD2 0px 0px 10px;
    			-moz-box-shadow: #A4DCD2 0px 0px 10px;
  }
  .xmnr img{

    width:50%;
    height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/zzkd/orderlist.vue